module.exports = __webpack_public_path__ + "static/media/Best-bike-advice-reviews.e1dfcb85.png";